/* eslint-disable @next/next/no-img-element */
import React, { ReactNode } from 'react';
import { twMerge } from 'utilities/src/twMerge';
import TrackedErrorBoundary from 'ui/src/components/TrackedErrorBoundary';
import Flyout from 'ui/src/components/Flyout';
import ButtonLink from 'ui/src/components/ButtonLink';
import { NewMenuItem } from 'ui/src/data/MenuItem';
import { AllIcons } from 'ui/src/components/Icon';
import MobileHeader from '../mobileHeader';
import { HeaderProps } from './HeaderContainer';
import useHeader from './hooks/useHeader';
import HeaderBGEnum from './HeaderBGEnum';

type HeaderContentProps = HeaderProps & {
  menuItems: NewMenuItem[];
  logoPath: string;
  headerLogoUrl?: string;
  headerLinkChildren?: ReactNode;
  ctaLabel?: string;
  ctaLink?: string;
  ctaIconName?: AllIcons;
};

export default function HeaderContent({
  headerLogoUrl,
  logoPath,
  headerLinkChildren,
  menuItems,
  ctaLink,
  ctaIconName,
  ctaLabel,
}: HeaderContentProps) {
  const { hasScrolled, bgHeader } = useHeader();

  return (
    <>
      <div className="flex">
        <a
          href={`${headerLogoUrl ?? 'https://www.bairesdev.com'}/`}
          aria-label="BairesDev home"
          className={twMerge('block h-[22px]')}
        >
          <div className={twMerge('h-7 w-8 overflow-hidden', 'mdS:w-auto', 'mdL:w-8', 'lgS:w-auto')}>
            <img
              src={logoPath}
              alt="BairesDev"
              width={188}
              height={28}
              className="h-7 w-48 cursor-pointer object-cover object-left"
              style={
                bgHeader !== HeaderBGEnum.Transparent || hasScrolled
                  ? {}
                  : { filter: 'invert(1) hue-rotate(180deg)' }
              }
            />
          </div>
        </a>
        {headerLinkChildren}
      </div>

      <div className={twMerge('mdL:h-full mdL:flex hidden h-auto')}>
        <nav aria-label="BairesDev main navigation" className="flex h-full items-center">
          <TrackedErrorBoundary id="flyout-error">
            <Flyout
              menuItems={menuItems}
              hasLeftText={!!headerLinkChildren}
              bgHeader={bgHeader}
              hasScrolled={hasScrolled}
            />
          </TrackedErrorBoundary>
          <ButtonLink
            variant="Primary"
            variantColor={bgHeader !== HeaderBGEnum.Transparent || hasScrolled ? 'Black' : 'White'}
            size="Medium"
            classes="ml-8 mdL:ml-2"
            href={`${ctaLink}`}
            iconName={ctaIconName}
            prefetch={false}
          >
            {ctaLabel}
          </ButtonLink>
        </nav>
      </div>

      <MobileHeader menuItems={menuItems} />
    </>
  );
}
